import React, { useState, useEffect } from 'react';
import { PractitionersTableCardComponent } from '../../../components/Cards/Practitioner';
import { useOrganization } from '../../../contexts/organization';
import { IPractitioner } from '../../../modules/unsw-fhir/Practitioner';
import { useDataApi } from '../../../modules/unsw-hooks';
import { getPractitionerRolesByOrganizationId } from '../../../apis/practitionerRole';
import { getPractitioners } from '../../../apis/practitioner';
import { IReference } from '../../../modules/unsw-fhir/Reference';

const isPractitionerReferenceEqual = (
  id: string | undefined,
  reference: IReference | undefined,
) => {
  if (!id || !reference) return false;
  if (!reference.reference) return false;

  const splits = reference.reference.split('/');

  return id === splits[splits.length - 1];
};

const PractitionerTable = () => {
  /*
  Due to the fact that we are unable to do _has look up with Azure's fhir server. 
  We have to do this client side.. :( E.G
    /Practitioner?_has:PractitionerRole:Organization=e472bb21-8a77-4cf4-b5ed-9341faf67110
    TODO: Fix this once server side supports _has 
*/

  const { organization } = useOrganization();
  const [{ data: practitionerRolesResponse }, setPractitionerRolesResponse] =
    useDataApi(
      getPractitionerRolesByOrganizationId,
      undefined,
      organization && organization.id,
    );
  const [{ data: practitionersResponse }] = useDataApi(
    getPractitioners,
    undefined,
  );

  const [practitioners, setPractitioners] = useState<IPractitioner[]>([]);
  const [loading, isLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!practitionerRolesResponse || !practitionersResponse) return;
    isLoading(true);
    const filtered = practitionersResponse.data.filter(practitioner => {
      return practitionerRolesResponse.data.find(
        pr =>
          isPractitionerReferenceEqual(practitioner.id, pr.practitioner) &&
          pr.active,
      );
    });

    setPractitioners(filtered);
    isLoading(false);
  }, [practitionerRolesResponse, practitionersResponse]);
  return (
    <PractitionersTableCardComponent
      practitioners={practitioners}
      practitionerRoles={
        practitionerRolesResponse ? practitionerRolesResponse.data : []
      }
      organizationId={organization && organization.id}
      loading={loading}
      onPractitionerRolesUpdate={
        setPractitionerRolesResponse
      }></PractitionersTableCardComponent>
  );
};

export default PractitionerTable;
